import React from "react";

import { cx } from "~/tools/class-variance";
import { isNumber } from "~/tools/is-number";

import { GenericErrorMessage } from "../../error/GenericErrorMessage";
import { type ChartSize, getChartSize } from "../_utils";

import noData from "./no-data.svg";

export interface ErrorChartProps {
	error: Error;
	size?: number | ChartSize;
	className?: string;
}

export const ErrorChart = React.forwardRef<React.ComponentRef<"div">, ErrorChartProps>(
	({ error, size, className }, ref) => (
		<div
			className={cx("mx-auto my-0 flex size-full flex-col items-center justify-center bg-left bg-repeat-x", className)}
			data-testid="chart-error"
			ref={ref}
			style={{
				backgroundImage: `url(${noData})`,
				minHeight: isNumber(size) ? size : getChartSize(size),
			}}
		>
			<GenericErrorMessage error={error} />
		</div>
	),
);
